const MultilineTooltipTitle = ({ lines }: { lines: string[] }) => (
  <div style={{ whiteSpace: "pre-line" }}>{lines.join("\n")}</div>
);

export default MultilineTooltipTitle;
